import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Button } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createDriver, updateDriver } from '../../common/drivers/actions'
import { validateSupervisor, validateAdmin, validateFleetManager } from '../../common/drivers/validations'
import { roles, genders } from '../../common/config'
import { loadCompanies } from '../../common/companies/actions'

const { Row, Column } = Grid

const genderOptions = Object.keys(genders).map(key => ({ value: key, text: genders[key] }))

class DriverForm extends React.Component {
  componentWillMount() {
    this.props.loadCompanies({ sort: 'nameSort' })
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, driver, createDriver, updateDriver } = this.props
    const isUpdate = driver && !!driver._id
    const values = fields.$values()
    let submissionFunction = createDriver

    if (isUpdate) {
      values._id = driver._id
      submissionFunction = updateDriver
    }

    if (await submit(values, submissionFunction) !== false) {
      fields.$reset()
    }
  }

  render() {
    const { fields, errors, role, attendSource, companyOptions, submitting, submitSuccessfull } = this.props

    if (submitSuccessfull && attendSource) return <Redirect to={'/attendances/' + attendSource} />
    if (submitSuccessfull) return <Redirect to="/drivers" />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field) fieldData[error.detail.field].error = error.message
    })
    if (role === roles.FLEET_MANAGER) {
      ['lastName', 'firstName', 'birthdate', 'gender'].forEach((key) => { fieldData[key].disabled = true })
    }
    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Základní údaje</Header>
            </Column>
          </Row>
          <Field label="Jméno" required {...fieldData.firstName} />
          <Field label="Příjmení" {...fieldData.lastName} required />
          <Field type="switch" label="Pohlaví" {...fieldData.gender} required options={genderOptions} />
          <Field label="Datum narození" type="date" {...fieldData.birthdate} required />
          <Field label="Email" type="Email" {...fieldData.email} />
          <Field label="Telefon" type="tel" {...fieldData.phoneNumber} />
          {role !== roles.FLEET_MANAGER &&
            <Field label="Dopravce" type="select" {...fields.company} options={companyOptions} required />
          }
          <Field type="checkbox" label="Pracovní poměr ukočen" {...fieldData.employmentFinished} />
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Header as="h2">
                Expirace
              </Header>
            </Column>
          </Row>
          <Field label="Řidičský průkaz" type="date" {...fieldData.drivingLicenceExpireDate} />
          <Field label="Lékařská&nbsp;prohlídka" type="date" {...fieldData.medicalExaminationExpireDate} />
          <Field label="Školení" type="date" {...fieldData.trainingExpireDate} />
          <Field label="ADR" type="date" {...fieldData.adrExpirationDate} />
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Button type="submit" onClick={(e) => this.submit(e)}>Uložit</Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

DriverForm.defaultProps = {
  driver: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

DriverForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  driver: React.PropTypes.object,
  attendSource: React.PropTypes.string,
  role: React.PropTypes.string.isRequired,
  errors: React.PropTypes.array,
  companyOptions: React.PropTypes.array.isRequired,
  loadCompanies: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

DriverForm = fields(DriverForm, {
  path: 'DriverForm',
  fields: [
    'lastName', 'firstName', 'company', 'birthdate', 'email', 'gender','employmentFinished',
	'drivingLicenceExpireDate', 'trainingExpireDate',
    'medicalExaminationExpireDate','adrExpirationDate', 'phoneNumber'
  ],
  getInitialState: (props) => {
    const { driver } = props
    if (driver && driver._id) return driver.toJS()
    return {}
  },
})

DriverForm = FormValidation(DriverForm, (props) => {
  const { role } = props
  let submissionValidation
  switch (role) {
    case roles.FLEET_MANAGER:
      submissionValidation = validateFleetManager
      break
    case roles.ADMIN:
      submissionValidation = validateAdmin
      break
    case roles.SUPERVISOR:
      submissionValidation = validateSupervisor
      break
    // no default
  }
  return { submissionValidation }
})

export default connect((state) => ({
  companyOptions: state.companies.all.map(c => ({ value: c._id, text: c.name })).toArray(),
}), { createDriver, updateDriver, loadCompanies })(DriverForm)



// WEBPACK FOOTER //
// ./src/browser/forms/Driver.js